import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { TrendingDown, CalendarX, Users, UserX } from 'lucide-react';
const problems = [{
  icon: TrendingDown,
  title: 'Desistência Precoce',
  description: 'Alunos começam motivados e desistem em poucos meses por falta de resultados visíveis.'
}, {
  icon: CalendarX,
  title: 'Falta de Acompanhamento',
  description: 'Avaliações físicas são feitas apenas no início, sem monitoramento contínuo da evolução.'
}, {
  icon: Users,
  title: 'Sobrecarga dos Professores',
  description: 'Professores cuidam de muitos alunos ao mesmo tempo, dificultando a atenção individual.'
}, {
  icon: UserX,
  title: 'Sensação de Abandono',
  description: "O aluno se sente 'largado' na academia e perde o interesse rapidamente."
}];
export function ProblemSection() {
  return <Section background="gray" data-id="element-123">
      <div className="text-center mb-16" data-id="element-124">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-[#2D3748] mb-4" data-id="element-125">
          O desafio de manter alunos engajados
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-126">
          A maioria das academias perde alunos pelos mesmos motivos. O Iron Gym
          resolve exatamente isso.
        </motion.p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-127">
        {problems.map((problem, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-gray-100" data-id="element-128">
            <div className="w-12 h-12 bg-red-50 rounded-lg flex items-center justify-center mb-6" data-id="element-129">
              <problem.icon className="h-6 w-6 text-red-500" data-id="element-130" />
            </div>
            <h3 className="text-xl font-bold text-[#2D3748] mb-3" data-id="element-131">
              {problem.title}
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-132">
              {problem.description}
            </p>
          </motion.div>)}
      </div>
    </Section>;
}